<p class="error-message full-width" *ngIf="hasError$ | async">
  Ar error occurred while trying to {{ errorGeneralMessage$ | async }}. Please
  contact support.
</p>

<div class="card-actions">
  <div class="card-transaction action-item">
    <button mat-button class="transaction-btn" (click)="transaction()">
      <mat-icon class="material-icons">sync_alt</mat-icon>
      TRANSACTIONS
    </button>
  </div>
  <ng-container *ngIf="!(isCancelStatus$ | async)">
    <div class="card-reveal-details action-item">
      <ng-container *ngIf="viewSensitiveData$ | async">
        <button
          mat-button
          class="reveal-details-btn"
          (click)="revealDetails()"
          terraCheckPermissions
          [minimumPermissionLevel]="PermissionLevel.Readonly"
          [minimumFinancialPermissionLevel]="
            FinancialPermissionLevel.AuthorizedSignatory
          "
          [noPermissionAction]="NoPermissionAction.PopupOnClick"
          [disabled]="loadingSensitiveData$ | async"
        >
          <mat-icon class="material-icons">visibility_off</mat-icon>
          HIDE DETAILS
        </button>
      </ng-container>
      <ng-container *ngIf="!(viewSensitiveData$ | async)">
        <button
          mat-button
          class="reveal-details-btn"
          (click)="revealDetails()"
          terraCheckPermissions
          [minimumPermissionLevel]="PermissionLevel.Readonly"
          [minimumFinancialPermissionLevel]="
            FinancialPermissionLevel.AuthorizedSignatory
          "
          [noPermissionAction]="NoPermissionAction.PopupOnClick"
          [disabled]="loadingSensitiveData$ | async"
        >
          <mat-icon class="material-icons">visibility</mat-icon>
          REVEAL DETAILS
        </button>
      </ng-container>
    </div>
    <div class="card-more-actions">
      <button
        mat-icon-button
        class="card-actions-menu-button"
        [matMenuTriggerFor]="cardActionMenu"
        [disabled]="isCancelStatus$ | async"
      >
        <mat-icon class="material-icons">more_vert</mat-icon>
      </button>
      <mat-menu #cardActionMenu="matMenu" class="card-actions-menu">
        <button
          mat-menu-item
          (click)="freeze()"
          class="action-menu-item"
          terraCheckPermissions
          [minimumPermissionLevel]="PermissionLevel.Editor"
          [minimumFinancialPermissionLevel]="
            FinancialPermissionLevel.AuthorizedSignatory
          "
          [noPermissionAction]="NoPermissionAction.PopupOnClick"
        >
          <mat-icon class="action-icon notranslate material-icons-outlined"
            >ac_unit</mat-icon
          >
          <span *ngIf="(cardStatus$ | async) === UnitCardStatus.Frozen"
            >Unfreeze</span
          >
          <span *ngIf="(cardStatus$ | async) !== UnitCardStatus.Frozen"
            >Freeze</span
          >
        </button>
        <button
          *ngIf="
            (cardStatus$ | async) === UnitCardStatus.Active &&
              cardIsPinCodeExist$ | async
          "
          mat-menu-item
          (click)="resetPin()"
          class="action-menu-item"
        >
          <mat-icon
            class="action-icon notranslate material-icons-outlined psychology-icon"
            >lock_reset</mat-icon
          >
          <span>Reset Pin</span>
        </button>
        <button
          *ngIf="
            (cardStatus$ | async) === UnitCardStatus.Active &&
            !(cardIsPinCodeExist$ | async)
          "
          mat-menu-item
          (click)="setPin()"
          class="action-menu-item"
        >
          <mat-icon
            class="action-icon notranslate material-icons-outlined psychology-icon"
            >lock</mat-icon
          >
          <span>Set Pin</span>
        </button>
        <button
          *ngIf="(cardStatus$ | async) !== UnitCardStatus.ClosedByCustomer"
          mat-menu-item
          (click)="cancelCard()"
          class="action-menu-item"
          terraCheckPermissions
          [minimumPermissionLevel]="PermissionLevel.Editor"
          [minimumFinancialPermissionLevel]="
            FinancialPermissionLevel.AuthorizedSignatory
          "
          [noPermissionAction]="NoPermissionAction.PopupOnClick"
        >
          <mat-icon class="action-icon notranslate psychology-icon"
            >cancel</mat-icon
          >
          <span>Cancel Card</span>
        </button>
      </mat-menu>
    </div>
  </ng-container>
</div>
